import createYCloudIcon from '../createYCloudIcon';

/**
 * @component @name StarMinus
 * @description YCloud SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMThoNiIgLz4KICA8cGF0aAogICAgZD0iTTE3LjY4OCAxNGEyLjEgMi4xIDAgMCAxIC40MTYtLjU2OGwzLjczNi0zLjYzOGEuNTMuNTMgMCAwIDAtLjI5NC0uOTA1bC01LjE2Ni0uNzU1YTIuMSAyLjEgMCAwIDEtMS41OTUtMS4xNmwtMi4zMS00LjY4YS41My41MyAwIDAgMC0uOTUuMDAxTDkuMjE2IDYuOTc0YTIuMSAyLjEgMCAwIDEtMS41OTcgMS4xNmwtNS4xNjUuNzU1YS41My41MyAwIDAgMC0uMjk0LjkwNmwzLjczNiAzLjYzN2EyLjEgMi4xIDAgMCAxIC42MTEgMS44NzlsLS44OCA1LjEzOWEuNTMuNTMgMCAwIDAgLjc2OS41Nmw0LjYxNy0yLjQyOC4wMjctLjAxNCIKICAvPgo8L3N2Zz4K) - https://tianjianjun0727.github.io/ycloud-icons/icons/star-minus
 * @see https://tianjianjun0727.github.io/ycloud-icons/guide/preact - Documentation
 *
 * @param {Object} props - YCloud icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StarMinus = createYCloudIcon('star-minus', [
  ['path', { d: 'M15 18h6', key: '3b3c90' }],
  [
    'path',
    {
      d: 'M17.688 14a2.1 2.1 0 0 1 .416-.568l3.736-3.638a.53.53 0 0 0-.294-.905l-5.166-.755a2.1 2.1 0 0 1-1.595-1.16l-2.31-4.68a.53.53 0 0 0-.95.001L9.216 6.974a2.1 2.1 0 0 1-1.597 1.16l-5.165.755a.53.53 0 0 0-.294.906l3.736 3.637a2.1 2.1 0 0 1 .611 1.879l-.88 5.139a.53.53 0 0 0 .769.56l4.617-2.428.027-.014',
      key: 'rwo527',
    },
  ],
]);

export default StarMinus;
